import React, { useEffect, useState } from 'react';
import { RefreshCw, Loader2, Globe } from 'lucide-react';
import { adminAPI } from '../../services/api';
import '../../styles/AdminShared.css';
import './Admin.css';

const SEOManagement: React.FC = () => {
  const [seoList, setSeoList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSEO();
  }, []);

  const loadSEO = async () => {
    try {
      const response = await adminAPI.getSEO();
      setSeoList(Array.isArray(response) ? response : (response as any).results || []);
    } catch (error) {
      console.error('Failed to load SEO data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-page adm-page">
        <div className="adm-topbar"><h1 className="adm-page-title">SEO Management</h1></div>
        <div className="adm-loading"><span className="adm-spin"><Loader2 size={20} /></span> Loading…</div>
      </div>
    );
  }

  return (
    <div className="admin-page adm-page">
      <div className="adm-topbar">
        <h1 className="adm-page-title">SEO Management</h1>
        <div className="adm-topbar-right">
          <button className="adm-btn adm-btn-refresh" onClick={loadSEO}><RefreshCw size={13} /> Refresh</button>
        </div>
      </div>
      <div className="adm-table-card">
        <div className="adm-table-scroll">
          <table className="adm-table">
            <thead>
              <tr>
                <th className="adm-th">Page Type</th>
                <th className="adm-th">Meta Title</th>
                <th className="adm-th">Meta Description</th>
                <th className="adm-th" style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {seoList.length === 0 && <tr><td colSpan={4} className="adm-empty"><Globe size={22} style={{ marginRight: 8 }} />No SEO metadata configured yet.</td></tr>}
              {seoList.map((item: any) => (
                <tr className="adm-row" key={item.id}>
                  <td className="adm-td"><span className="adm-chip adm-chip-blue">{item.page_type}</span></td>
                  <td className="adm-td"><span className="adm-name-main">{item.meta_title}</span></td>
                  <td className="adm-td"><span className="adm-text-muted">{item.meta_description}</span></td>
                  <td className="adm-td" style={{ textAlign: 'center' }}>
                    <button className="adm-action-btn adm-ab-edit" title="Edit">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SEOManagement;
